import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[appUiTableBodyCells]', standalone: true })
export class UiTableBodyCellsDirective {
  constructor(public template: TemplateRef<any>) {}
}
